import {
  GROUP_ADD_NEW,
  GROUP_ADD_MULTIPLE,
  GROUP_DELETE_SIZE_FROM_GROUP,
  GROUP_ADD_NEW_SIZE_TO_GROUP
} from 'constants/actiontypes';

const INITIAL_STATE = []

export default (state=INITIAL_STATE, action) => {
  switch (action.type) {
    case GROUP_ADD_NEW:
      return state.concat([{
        id: action.id,
        name: action.name,
        sizes: action.sizes || [],
        // userId: action.user_id,
      }]);
    case GROUP_ADD_MULTIPLE:
      return action.groups.map((group, index) => ({
        id: group.id,
        name: group.name,
        sizes: group.sizes || []
      }));
    case GROUP_ADD_NEW_SIZE_TO_GROUP:
      return state.map((group) => {
        if (action.groupId !== group.id) {
          return group;
        }
        return Object.assign({}, group, {
          sizes: group.sizes.concat([{
            id: action.id,
            // userId: action.user_id,
            name: action.name,
            width: action.width,
            height: action.height,
          }])
        });
      });
    case GROUP_DELETE_SIZE_FROM_GROUP:
      return state.map((group) => {
        if (action.groupId !== group.id) {
          return group;
        }
        return Object.assign({}, group, {
          sizes: group.sizes.filter(size => (size.id !== action.id))
        });
      });
    default: return state;
  }
  return state;
};



/** WEBPACK FOOTER **
 ** ./reducers/imagegroup.js
 **/